import React, { FC, useEffect, useState } from 'react';

import { BUTTON_TYPES, EvFlexRow, EvSwitch } from '@evinced-private/ui-common';

import {
	DevelopmentToggles,
	getSingleToggle,
	removeToggle,
	setToggle
} from 'src/common/services/TogglesService';

import { PlatformPopup } from '../platform-popup/PlatformPopup';

import './DevTogglesPopup.scss';

const TOGGLES_DETAILS = [
	{ name: DevelopmentToggles.CAN_ACCESS_MFA_DASHBOARD, label: 'Can access MFA dashboard view' },
	{
		name: DevelopmentToggles.CAN_ACCESS_MOBILE_SDK_DASHBOARD,
		label: 'Can access Mobile SDK dashboard view'
	},
	{
		name: DevelopmentToggles.CAN_ACCESS_WEB_SDK_DASHBOARD,
		label: 'Can access Web SDK dashboard view'
	},
	{
		name: DevelopmentToggles.CAN_ACCESS_WFA_DASHBOARD,
		label: 'Can access WFA dashboard view'
	},
	{ name: DevelopmentToggles.ENABLE_WEB_SDK_PROPERTIES, label: 'Enable Web SDK Properties' }
];

interface IDevTogglesPopup {
	closePopup: () => void;
	isOpen: boolean;
}

export const DevTogglesPopup: FC<IDevTogglesPopup> = ({ closePopup, isOpen }: IDevTogglesPopup) => {
	const [toggles, setToggles] = useState<Partial<Record<DevelopmentToggles, boolean>>>({});

	const setTogglesState = (): void => {
		const newState: Partial<Record<DevelopmentToggles, boolean>> = {};
		TOGGLES_DETAILS.forEach((toggle) => {
			const state = getSingleToggle(toggle.name, false);
			newState[toggle.name] = state;
		});
		setToggles(newState);
	};

	useEffect(() => {
		setTogglesState();
	}, []);

	const onChange = (type: DevelopmentToggles) => {
		return (state: boolean): void => {
			setToggles({ ...toggles, [type]: state });
		};
	};

	const saveChanges = (): void => {
		TOGGLES_DETAILS.forEach((toggle) => {
			if (toggles[toggle.name]) {
				setToggle(toggle.name, 'true');
			} else {
				removeToggle(toggle.name);
			}
		});
	};

	const onClose = (): void => {
		setTogglesState();
		closePopup();
	};

	const buttons = [
		{
			title: 'Cancel',
			onClick: onClose,
			type: BUTTON_TYPES.GHOST
		},
		{
			title: 'Save',
			onClick: () => {
				saveChanges();
				closePopup();
			}
		}
	];
	return (
		<PlatformPopup
			title="Dev Toggles"
			isControlled
			isOpen={isOpen}
			onClose={onClose}
			buttons={buttons}
			isCentered={true}
			className="dev-toggles-popup"
		>
			<div className="popup-form">
				{TOGGLES_DETAILS.map(({ label, name }) => {
					return (
						<EvFlexRow key={name} align="CENTER" margin={['NONE', 'NONE', 'SMALL', 'NONE']}>
							<EvSwitch label={label} checked={toggles[name] ?? false} onChange={onChange(name)} />
						</EvFlexRow>
					);
				})}
			</div>
		</PlatformPopup>
	);
};
